import { render } from "./Payment.vue?vue&type=template&id=5e61fc34&scoped=true&ts=true"
import script from "./Payment.vue?vue&type=script&lang=ts"
export * from "./Payment.vue?vue&type=script&lang=ts"

import "./Payment.vue?vue&type=style&index=0&id=5e61fc34&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e61fc34"]])

export default __exports__